import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {
  createBrowserRouter,
  RouterProvider,
  Route,
} from "react-router-dom";
import Winner from './Winner';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "generar-sorteo",
    element: <Winner />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);


